/* eslint-disable react/jsx-props-no-spreading */
import { FC, useState } from 'react';

import { TextField, ITextFieldProps } from '../TextField';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { IconButton } from '@mui/material';

export const PasswordField: FC<ITextFieldProps> = ({ ...props }) => {
    const [passwordIsVisible, setPasswordIsVisible] = useState(false);

    const passwordVisibilityButton = (
        <IconButton
            size="small"
            aria-label={passwordIsVisible ? 'Hide password' : 'Show password'}
            onClick={() => setPasswordIsVisible(!passwordIsVisible)}
        >
            {passwordIsVisible ? <Visibility /> : <VisibilityOff />}
        </IconButton>
    );

    return (
        <TextField
            {...props}
            type={passwordIsVisible ? 'text' : 'password'}
            InputProps={{ endAdornment: passwordVisibilityButton, ...props.InputProps }}
        />
    );
};
